import React from 'react';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { useMediaQuery } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { ReactComponent as AlertIcon } from '../../../../assets/images/alert-circle.svg';
var AcceptIRPoup = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            gap: '16px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                                height: '20px',
                                width: '20px'
                            }),
                            columnSize: 0,
                            sx: {
                                bgcolor: 'warning.100',
                                cursor: 'default',
                                padding: '12px',
                                color: 'warning.500',
                                ':hover': {
                                    bgcolor: 'warning.100'
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Msg',
                    label: 'Are you sure you want to resend to PSG?',
                    value: null,
                    columnSize: 12,
                    children: 'Actions taken cannot be undone.',
                    labelTypographyProps: {
                        fontSize: "xl",
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'secondary.600'
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: '',
                    label: 'Resend reason',
                    placeholder: 'E.g. Failed sample required',
                    valueExpr: '',
                    displayExpr: '',
                    columnSize: 12
                }, {
                    type: FormItemTypes.TextInput,
                    name: '',
                    label: 'CQA remarks',
                    columnSize: 12,
                    multiline: true,
                    minRows: 4,
                    placeholder: 'Enter a description'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    onClick: function () {
                        onClose();
                    },
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Confirm',
                    onClick: function () {
                        onClose('confirm');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained'
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
export default AcceptIRPoup;
